var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.29167 0.461728C6.62981 0.163541 7.05779 0 7.5 0C7.94221 0 8.37019 0.163541 8.70833 0.461728L14.3333 5.42748C14.7567 5.79981 15 6.34826 15 6.92724V15.4741C15 15.8788 14.8464 16.2669 14.5729 16.5531C14.2994 16.8392 13.9284 17 13.5417 17H11.0417C10.6549 17 10.284 16.8392 10.0105 16.5531C9.73698 16.2669 9.58333 15.8788 9.58333 15.4741V11.1143C9.58333 10.9409 9.51748 10.7746 9.40027 10.6519C9.28306 10.5293 9.12409 10.4604 8.95833 10.4604H6.04167C5.87591 10.4604 5.71694 10.5293 5.59973 10.6519C5.48251 10.7746 5.41667 10.9409 5.41667 11.1143V15.4741C5.41667 15.8788 5.26302 16.2669 4.98953 16.5531C4.71604 16.8392 4.34511 17 3.95833 17H1.45833C1.26682 17 1.07719 16.9605 0.900253 16.8838C0.72332 16.8072 0.562555 16.6948 0.427136 16.5531C0.291717 16.4114 0.184297 16.2432 0.111009 16.058C0.037721 15.8729 0 15.6745 0 15.4741V6.92636C0 6.34826 0.243333 5.79981 0.666667 5.42661L6.29167 0.461728Z",
    fill: "#5282F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.c43674fb7b98063cb158e58c7ddafcb4.svg";
export { ForwardRef as ReactComponent };